import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Sparkles } from "lucide-react";
import { api } from "@/lib/apiClient";
import { PromoCountdown } from "@/lib/promo";
import { isNative } from "@/lib/native";

// Gold "free reading" banner on Today while an offer is live and the member hasn't claimed it.
export default function OfferBanner({ isPremium }) {
  const [promo, setPromo] = useState(null);
  useEffect(() => {
    if (!isNative) api.get("/promotions/current").then(({ data }) => setPromo(data.promo)).catch(() => {});
  }, []);
  if (!promo || promo.claimed) return null;
  return (
    <Link to={`/readings/${promo.slug}`} data-testid="today-offer-banner"
      className="group block mb-4 rounded-2xl p-[1px] bg-gradient-to-r from-[#D4AF37] via-[#f3dd8a] to-[#b8912a] shadow-[0_10px_30px_rgba(212,175,55,0.25)] fade-up">
      <div className="rounded-2xl bg-gradient-to-br from-[#2a2110] via-[#14110a] to-[#0B0F19] px-5 py-4">
        <span className="inline-flex items-center gap-1.5 text-[10px] uppercase tracking-[0.25em] bg-[#D4AF37] text-[#04060B] px-3 py-1 rounded-full">
          <Sparkles size={11} /> Free reading{promo.extended ? " · extended" : ""}
        </span>
        <p className="text-2xl font-light mt-2 text-starlight" data-testid="today-offer-title">Your free {promo.title}</p>
        <p className="text-sm text-[#E8DCC4] mt-1">{isPremium ? "Included with your Premium. Claim it before the offer ends." : "Free when you join Astra Premium, for a limited time."}</p>
        <div className="flex flex-wrap items-center justify-between gap-3 mt-3">
          <PromoCountdown endsAt={promo.ends_at} />
          <span className="inline-flex items-center gap-1.5 gold-text text-sm group-hover:gap-2.5 transition-[gap]" data-testid="today-offer-cta">Claim it free <ArrowRight size={15} /></span>
        </div>
      </div>
    </Link>
  );
}
